/** Equal side tracks keep selectors centered in the full conversation region. */
export const CONVERSATION_HEADER_COLUMNS = 'minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1fr)'
export const HARNESS_CONVERSATION_NAME = 'DeepSeek Harness'
